import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import TextBlock from '../../../components/TextBlock'
import ProjectDetails from '../../../components/ProjectDetails'
import ProjectHeader from '../../../components/ProjectHeader'
import SingleImage from '../../../components/SingleImage'
import AHref from '../../../components/AHref'

import featureImage from './kincare-preview_1600.jpg'
import featureImage2 from './kincare-desktop_1600.jpg'
import UX from './kincare-roadmapping.jpg'

import './index.scss'

class KinCare extends Component {
  render () {
    const { children } = this.props

    return (
      <div>
        <ProjectHeader
          heading="A new platform to support the leaders of in-home care"
          client="KinCare"
        />
      <SingleImage img={featureImage} margin />
      <ProjectDetails
        role="User experience designer"
        client="KinCare"
        agency="Pollen"
        agencylink="https://wwww.pollen.com.au"
        deliverables="User research, site reviews, competitor reviews, analytics and optimisation, information architecture, wireframes, user flows, prototyping"
      >
      <h2 className="h6">Background</h2>
      <p>KinCare is one of Australia’s largest in-home, aged-care and disability support providers. In early 2017, <AHref url="https://agedcare.health.gov.au/aged-care-reform/home-care/home-care-packages-reform">as choice for in-home aged care providers became customer-directed</AHref>, Pollen partnered with KinCare to refresh their brand and completely overhaul their website – the forefront of the KinCare staff and customer experience.</p>
      <p>Alongside the team at Pollen, I worked across strategy, design and development to build and optimise a new website that better supported the KinCare customer journey. </p>
      <p><AHref url="https://wwww.kincare.com.au">Visit the KinCare website</AHref></p>
      </ProjectDetails>
      <SingleImage img={featureImage2} margin />
      <TextBlock>
        <h2 className="h6">User experience design and discovery</h2>
        <p>To better understand the KinCare customer and business, I worked with Pollen’s Experience Design Director <AHref url="https://au.linkedin.com/in/adrianwiggins">Adrian Wiggins</AHref> to define, develop and deliver a range of user research, including interviews, personas, customer journey maps, flow maps, and analytics reviews.</p>
      </TextBlock>
      <SingleImage img={UX} small caption="Picture by Jeremy Simons http://www.jeremysimons.com.au/" />
      <TextBlock>
        <h2 className="h6">A new modular platform</h2>
        <p>This research supported the design of wireframes, prototypes and information architecture which laid the foundation for a robust new platform that accommodated for the range of new content that Pollen developed alongside the new site. The new platform uses a number of module-based templates for flexible page creation.</p>
        <h2 className="h6">New features and pages</h2>
        <p>I was also responsible for strategy and user experience design for a number of new pages and features.</p>
        <p>I developed the user experience of 16,000 dynamic pages of new content that helped improve search engine visibility, drive traffic and generate leads.</p>
        <p>I also developed the user experience of service pages that helped explain the breadth and depth of KinCare's services to their customers.</p>
        <p>Most recently, I crafted the strategy and experience of KinCare’s flexible respite calculator, a new tool that demonstrates how flexible respite can be easily tailored to the needs of a carer and care recipient.</p>
        <h2 className="h6">Results</h2>
        <p>Over the course of a year, we drove an increase in online enquiries by potential customers and saw significant improvements of key engagement metrics including:</p>
        <ul>
          <li>– Decreased bounce rate by 16%</li>
          <li>– Increase in pages per session by 22%</li>
          <li>– Increase in time on site by 33%</li>
          <li>– Increased SEO visibility by four figures, including increased traffic to careers pages by 240%</li>
        </ul>
        <p>Pollen and KinCare continue to work together to evolve their digital business. The website just one part of KinCare’s larger, ongoing evolution as a first-rank provider of in-home, aged care and disability support services.</p>
      </TextBlock>
      </div>
    )
  }
}

KinCare.propTypes = {
  children: PropTypes.node.isRequired,
}

export default KinCare



// WEBPACK FOOTER //
// ./src/pages/projects/kincare/index.js